import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';

const ModifyButton = ({ mode, id, toggleMode, tooltipModify, tooltipCancel, strings, name }) => (
  <div className="block-actions">
    {mode === 'view' ? (
      <MuiThemeProvider theme={theme}>
        <Tooltip key={`tooltip-modify-${id}-${name}`} title={strings[tooltipModify] || 'Modify'} placement="top">
          <IconButton
            size="small"
            key={`icon-modify-${id}-${name}`}
            aria-label={strings[tooltipModify]}
            color="primary"
            onClick={toggleMode}
            // onTouchEnd={toggleMode}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </MuiThemeProvider>
    ) : (
      <>
        <MuiThemeProvider theme={theme}>
          <Tooltip key={`tooltip-cancel-${id}-${name}`} title={strings[tooltipCancel] || 'Cancel'} placement="top">
            <IconButton
              size="small"
              key={`icon-cancel-${id}-${name}`}
              aria-label={strings[tooltipCancel]}
              color="primary"
              onClick={toggleMode}
              // onTouchEnd={toggleMode}
            >
              <CancelIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </MuiThemeProvider>
      </>
    )}
  </div>
);

ModifyButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  toggleMode: PropTypes.func,
  tooltipModify: PropTypes.string,
  tooltipCancel: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  mode: PropTypes.oneOf(['view', 'edit']),
};

ModifyButton.defaultProps = {
  toggleMode: () => {},
  tooltipModify: 'party.edit.block.button.modify.label',
  tooltipCancel: 'party.edit.block.button.cancel.label',
  strings: {},
  mode: 'view',
};

export default ModifyButton;
